/** Show a wizard step by id, hide all others */
export function showStep(stepId: string): void {
  const steps = document.querySelectorAll<HTMLElement>('.step');
  steps.forEach((step) => step.classList.remove('active'));

  const target = document.getElementById(stepId);
  if (target) {
    // Small delay to allow CSS transition
    requestAnimationFrame(() => {
      target.classList.add('active');
    });
  }
}

/** Show an element */
export function show(el: HTMLElement): void {
  el.classList.remove('hidden');
}

/** Hide an element */
export function hide(el: HTMLElement): void {
  el.classList.add('hidden');
}

/** Flash a "detected note" popup */
export function flashNote(noteName: string): void {
  const el = document.getElementById('detected-note')!;
  const textEl = document.getElementById('detected-note-text')!;
  textEl.textContent = noteName;
  el.classList.remove('hidden');
  el.classList.add('show');

  setTimeout(() => {
    el.classList.remove('show');
    setTimeout(() => el.classList.add('hidden'), 200);
  }, 600);
}

/** Show a milestone toast */
export function showMilestone(message: string): void {
  const el = document.getElementById('milestone-toast')!;
  const textEl = document.getElementById('milestone-text')!;
  textEl.textContent = message;
  el.classList.remove('hidden');
  el.classList.add('show');

  setTimeout(() => {
    el.classList.remove('show');
    setTimeout(() => el.classList.add('hidden'), 300);
  }, 2000);
}

/** Update the progress bar and text */
export function updateProgress(current: number, total: number): void {
  const fill = document.getElementById('progress-fill')!;
  const text = document.getElementById('progress-text')!;
  const completed = current - 1;
  const pct = Math.min((completed / total) * 100, 100);
  fill.style.width = `${pct}%`;
  text.textContent = `${completed} / ${total}`;
}

/** Update the recording subtitle with current note info */
export function updateRecordingInfo(keyNum: number, noteName: string): void {
  const keyNumEl = document.getElementById('current-key-num')!;
  const subtitleEl = document.getElementById('recording-subtitle')!;
  keyNumEl.textContent = String(keyNum);
  subtitleEl.textContent = `Play ${noteName}`;
}

/** Get element by ID with type safety */
export function $(id: string): HTMLElement {
  return document.getElementById(id)!;
}
